module.exports = __webpack_public_path__ + "img/flow_1.079b9b0a.png";